import type React from 'react';

import { twMerge } from 'tailwind-merge';

interface Props {
  children: React.ReactNode;
  className?: string;
}
export const PageTitle = (props: Props) => {
  const { children, className = 'mb-4' } = props;
  return (
    <h2
      className={twMerge(
        'text-balance font-heading text-4xl font-bold text-app-text lg:text-6xl lg:leading-tight',
        className
      )}
    >
      {children}
    </h2>
  );
};
